import { reactive, watch, computed, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { getPatentImages } from '@/infrastructure/api-functions';
import { ImagePanelService } from '@eureka/shared/solution-card'
import type { ImageRecord } from '@/types';

export function useDetailImage() {
    const route = useRoute();
    const imagePanelService = reactive(new ImagePanelService());
    const patentId = computed(() => route?.params?.id as string)
    const data = reactive<{
        images: ImageRecord[],
        isLoading: boolean,
    }>({
        images: [],
        isLoading: true,
    });

    const stopWatcher = watch(() => {
        return [patentId.value]
    }, () => {
        data.isLoading = true;
        getPatentImages(patentId.value, { with_patent_image: true, limit: 100000 }).then(
            ({ records }) => {
                data.images = records;
                imagePanelService.imageList = records;
            }
        ).finally(() => {
            data.isLoading = false;
        })
    }, { immediate: true, flush: 'post' })

    onBeforeUnmount(() => {
        stopWatcher();
    });
    return {
        data,
        imagePanelService,
    };
}
